import { types } from "../types/types"

const initialState = {
    modalOpenPdf: false,
    pdfBlob: null,
    pdfFilename: null,
}

export const uiPdfReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.uiOpenModalPdf:
            return {
                ...state,
                modalOpenPdf: true
            }

        case types.uiCloseModalPdf:
            return {
                ...state,
                modalOpenPdf: false
            }
        case 'uiSetPdfBlob':
            return {
                ...state,
                pdfBlob: action.payload.blob,
                pdfFilename: action.payload.filename
            }
        case 'uiClearPdfBlob':
            return {
                ...state,
                pdfBlob: null,
                pdfFilename: null,
            }
        default:
            return state;
    }
}